function correctCamelCaseWord(text: string): string {
    return (
        (!!text &&
            !!text.length &&
            text.length > 1 &&
            `${text.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}`) ||
        ''
    );
}

export default correctCamelCaseWord;
